<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title collection-header">
				<span>活动管理 / 活动合集管理</span>
				<el-button type="primary" @click="$router.push('/event/collectionEdit')">新增</el-button>
			</div>
			<el-form :inline="true" :model="query" class="margin_top_20 margin_left_20">
				<el-form-item label="合集类型">
					<el-select v-model="query.event_category" clearable placeholder="全部">
						<el-option label="Web3" value="web3" />
						<el-option label="AI" value="ai" />
					</el-select>
				</el-form-item>
				<el-form-item label="标题或ID">
					<el-input v-model.trim="query.keyword" clearable @keyup.enter.native="search" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
					<el-button @click="reset">重置</el-button>
				</el-form-item>
			</el-form>

			<el-table v-loading="loading" :data="list" border>
				<el-table-column prop="id" label="ID" width="90" />
				<el-table-column prop="title" label="合集名称" min-width="260" />
				<el-table-column label="合集类型" width="120">
					<template slot-scope="scope">{{ scope.row.event_category === "ai" ? "AI" : "Web3" }}</template>
				</el-table-column>
				<el-table-column prop="activity_count" label="活动数量" width="120" />
				<el-table-column label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
						<el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="collection-pagination">
				<el-pagination
					background
					layout="total, prev, pager, next"
					:total="total"
					:page-size="query.size"
					:current-page.sync="query.page"
					@current-change="load"
				/>
			</div>
		</el-card>
	</div>
</template>

<script>
import { getEventCollections, deleteEventCollection } from "@/api/eventCollections";

export default {
	name: "EventCollectionList",
	data() {
		return {
			loading: false,
			list: [],
			total: 0,
			query: { page: 1, size: 10, event_category: "", keyword: "" },
		};
	},
	created() { this.load(); },
	methods: {
		load() {
			this.loading = true;
			getEventCollections(this.query).then((res) => {
				if (res.code === 200) {
					this.list = res.data.list || [];
					this.total = res.data.total || 0;
				} else this.$message.error(res.message);
			}).catch((error) => this.$message.error(error.message)).finally(() => { this.loading = false; });
		},
		search() { this.query.page = 1; this.load(); },
		reset() { this.query = { page: 1, size: 10, event_category: "", keyword: "" }; this.load(); },
		edit(id) { this.$router.push({ path: "/event/collectionEdit", query: { id } }); },
		remove(row) {
			this.$confirm(`确认删除活动合集「${row.title}」吗？删除合集不会删除其中的ME活动。`, "提示", { type: "warning" })
				.then(() => deleteEventCollection(row.id))
				.then((res) => { if (res.code === 200) { this.$message.success("删除成功"); this.load(); } else this.$message.error(res.message); })
				.catch((error) => { if (error !== "cancel") this.$message.error(error.message); });
		},
	},
};
</script>

<style scoped>
.collection-header { display: flex; align-items: center; justify-content: space-between; }
.collection-pagination { margin-top: 24px; text-align: right; }
.danger { color: #f56c6c; }
</style>
